import { useEffect, useRef } from 'react';

const useVideoAutoplay = (videoRef, options = { threshold: 0.5 }) => {
  useEffect(() => {
    const video = videoRef.current;

    if (!video) return; // Se não houver vídeo, não faz nada

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play(); // Inicia a reprodução quando a seção está visível
        } else {
          video.pause(); // Pausa o vídeo quando a seção não está visível
        }
      });
    }, options);

    // Observa o elemento pai do vídeo (ou o próprio vídeo)
    const parentElement = video.parentElement;
    if (parentElement) {
      observer.observe(parentElement);
    }

    // Limpa o observer ao desmontar o componente
    return () => {
      if (parentElement) {
        observer.unobserve(parentElement);
      }
    };
  }, [videoRef, options]);
};

export default useVideoAutoplay;
